import { lazy, Suspense, type PropsWithChildren } from 'react';
import FadeContent from '@/common/components/reactBits/FadeContent';
import SpotlightCard from '@/common/components/reactBits/SpotlightCard';

const Ferrofluid = lazy(
  () => import('@/common/components/reactBits/Ferrofluid')
);

export function LandingAtmosphere({ enabled }: { enabled: boolean }) {
  return (
    <div className="lp-atmosphere" aria-hidden="true">
      <div className="lp-orbit lp-orbit-one" />
      <div className="lp-orbit lp-orbit-two" />
      {enabled && (
        <Suspense fallback={null}>
          <Ferrofluid />
        </Suspense>
      )}
      <div className="lp-grid" />
    </div>
  );
}

export function LandingReveal({ children }: PropsWithChildren) {
  return (
    <FadeContent duration={850} threshold={0.03}>
      {children}
    </FadeContent>
  );
}

/** Pointer coordinates stay local to marketing; shared app cards stay unchanged. */
export function LandingSpotlight({ children }: PropsWithChildren) {
  return (
    <div
      className="lp-spotlight"
      onPointerMove={(event) => {
        const bounds = event.currentTarget.getBoundingClientRect();
        event.currentTarget.style.setProperty(
          '--lp-pointer-x',
          `${event.clientX - bounds.left}px`
        );
        event.currentTarget.style.setProperty(
          '--lp-pointer-y',
          `${event.clientY - bounds.top}px`
        );
      }}
    >
      <SpotlightCard>{children}</SpotlightCard>
    </div>
  );
}
